/**
 * Tenant Domain Models
 *
 * Pure TypeScript interfaces representing tenant configuration.
 * These are used internally by the data and application layers.
 */

import { environment } from '../../../../environments/environment';

export interface TenantDto {
  uuid: string,
  name: string,
  logoUrlMain: string,
  logoUrlSmall: string,
  tagline: string
}


export interface TenantConfig {
  uuid: string;
  name: string;
  /** IANA timezone for this tenant, e.g. 'Europe/London'. Defaults to UTC if absent. */
  timezone?: string;
  branding: TenantBranding;
  mediaVisualiser?: TenantMediaVisualiserConfig;
}

export interface TenantVm {
  branding: TenantBranding;
  name: string;
  /** IANA timezone for this tenant. Falls back to 'UTC' when absent. */
  timezone: string;
  isLoading: boolean;
  error: string | null;
}

export interface TenantMediaVisualiserConfig {
  videoAllowedOrigins?: string[];
  imageAllowedOrigins?: string[];
}

export interface TenantBranding {
  logoUrlMain: string;
  logoUrlSmall: string;
  tagline: string;
}


export function mapBackendTenantToAngular(dto: TenantDto): TenantConfig {
  return {
    uuid: dto.uuid,
    name: dto.name,
    branding: {
      tagline: dto.tagline,
      logoUrlMain: `${environment.apiBaseUrl}${dto.logoUrlMain}`,
      logoUrlSmall: `${environment.apiBaseUrl}${dto.logoUrlSmall}`,
    },
  };
}
